import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  EnumHITLDecisionType,
  EnumHITLStatus,
  IHITLActionRequest,
  IHITLDecision,
  IHITLRequest,
  IHITLReviewConfig
} from '../../interfaces/hitl.interface';
import { MarkdownFormatterService } from '../../services/markdown-formatter.service';

@Component({
  selector: 'sgt-approval-card',
  templateUrl: './approval-card.component.html',
  styleUrls: ['./approval-card.component.scss']
})
export class ApprovalCardComponent {
  @Input() interrupt!: IHITLRequest;
  @Input() submitting = false;
  @Input() readonly = false;

  @Output() respond = new EventEmitter<IHITLDecision[]>();

  readonly decisionType = EnumHITLDecisionType;
  readonly rejectControl = new FormControl('');
  readonly agentAvatar = 'assets/img/aya-agent-avatar.jpg';

  showRejectReason = false;

  constructor(private markdownFormatter: MarkdownFormatterService) {}

  trackByActionName(_index: number, action: IHITLActionRequest): string {
    return action.name;
  }

  /** Só oferece o que todas as ações admitem: a decisão vale para o lote inteiro. */
  allows(type: EnumHITLDecisionType): boolean {
    const actions = this.actions;
    if (!actions.length) {
      return false;
    }
    return actions.every((action) => !!this.configFor(action)?.allowed_decisions.includes(type));
  }

  contentHtml(action: IHITLActionRequest): string {
    const markdown = action.payload_markdown ?? action.description;
    return markdown ? this.markdownFormatter.format(markdown) : '';
  }

  onApprove(): void {
    if (this.submitting) {
      return;
    }
    this.respond.emit(this.actions.map(() => ({ type: EnumHITLDecisionType.APPROVE })));
  }

  openReject(): void {
    this.showRejectReason = true;
  }

  cancelReject(): void {
    this.showRejectReason = false;
    this.rejectControl.reset('');
  }

  onConfirmReject(): void {
    if (this.submitting) {
      return;
    }
    const message = (this.rejectControl.value ?? '').trim();
    this.respond.emit(
      this.actions.map(() => ({ type: EnumHITLDecisionType.REJECT, message: message || undefined }))
    );
  }

  /** Cada ação tem a sua configuração; o backend valida na ordem de `action_requests`. */
  private configFor(action: IHITLActionRequest): IHITLReviewConfig | undefined {
    return this.interrupt?.review_configs?.find((config) => config.action_name === action.name);
  }

  private get actions(): IHITLActionRequest[] {
    return this.interrupt?.action_requests ?? [];
  }

  get isCancelled(): boolean {
    return this.interrupt?.status === EnumHITLStatus.CANCELLED;
  }

  get headerLabel(): string {
    if (!this.readonly) {
      return 'Confirmação necessária';
    }
    return this.isCancelled ? 'Cancelado' : 'Aprovado';
  }

  get headerIcon(): string {
    if (!this.readonly) {
      return 'fas fa-shield-alt';
    }
    return this.isCancelled ? 'fas fa-times-circle' : 'fas fa-check-circle';
  }
}
